import styled from 'styled-components';

/**
 * Shared chrome for the "pick one thing" modals — Replace Image / Logo / Video
 * / Headshot, Replace Captions, and Add/Replace Intro Card, End Card, Name
 * Card and Hook.
 *
 * They are one family and read as one only if they share a silhouette: every
 * copy used to hand-roll its own card at a different width (500 / 560 / 600 /
 * 660px) with its own radius and elevation, so opening two in a row made the
 * dialog appear to jump and resize.
 */

/**
 * Horizontal inset for every row inside a picker modal — title, tabs, search,
 * grid, footer. The card itself is padded vertically only, so each row applies
 * this and they all line up on one edge.
 *
 * Rows nested in a component that brings its own padding subtract it from this
 * (see `TabsInset` in PhotosModal) rather than picking a different number.
 */
export const PICKER_MODAL_INSET = 'var(--spacing-lg)';

/**
 * The card: an elevated `--surface` panel on the dialog scaffold's tokens
 * (see docs/design-system.md → "Modals & Dialogs"). 640px matches the
 * `OverlayGraphicPickerModal` picker, the widest member of the family and the
 * one whose 3-up grid sets the floor.
 *
 * A flex column, so a footer action can sit at the bottom via `order`.
 */
export const PickerModalCard = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: min(640px, calc(100vw - 2 * var(--spacing-lg)));
  padding: var(--spacing-lg) 0;
  background-color: var(--surface);
  color: var(--text-secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  box-shadow: var(--elevation-lg);
`;
